module.exports = __webpack_public_path__ + "media/assets/images/ping_icon_gray-0ee11a1f3b074cba96c79b99bad279d9.png";